import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ThresholdApiService} from '../../services/api/statistics/threshold/threshold-api.service';

@Injectable()
export class ThresholdsResolver implements Resolve<any> {
    constructor(private thresholdApiService: ThresholdApiService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        return this.thresholdApiService.getThresholdStructure();
    }

}
